<template>
  <div>
    <el-tag
      v-if="loading"
      size="small"
      type="info"
      style="margin-top: 5px;"
    >
      <i class="el-icon-loading"></i> Készlet betöltése...
    </el-tag>
    <el-tag
      v-if="!loading"
      size="small"
      :type="stock > 0 ? 'success' : 'danger'"
      :loading="loading"
      style="margin-top: 5px;"
    >
      {{ stock | bigNumber }} db készleten
    </el-tag>
  </div>
</template>
<script>
export default {
  props: {
    productId: {
      type: Number,
      required: true,
    },
    storageId: {
      type: Number,
      default() {
        return 1;
      },
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      stock: 0,
    };
  },
  watch: {
    productId() {
      this.loadStock();
    },
  },
  async mounted() {
    await this.loadStock();
  },
  methods: {
    async loadStock() {
      this.loading = true;
      const stocks = await axios.get(`api/storages/${this.storageId}/stock/product/${this.productId}`);
      let sum = 0;
      stocks.forEach(stock => {
        sum += stock.count * stock.pack.count_per_pack;
      });
      this.stock = sum;
      this.loading = false;
    },
  },
};
</script>
